import '@/modules/card';
import Swiper from 'swiper';
import SwiperCore, { Pagination, Navigation, Scrollbar } from 'swiper/core';
import 'swiper/css';
SwiperCore.use([Pagination, Navigation, Scrollbar]);

export default class BlogCategory {
    /**
        * Class constructor *
        * @arg {object} - `sliderElement` check for the
        * product carousel element.
    **/
    constructor (sliderElement) {
        if (!sliderElement) return;

        this.sliderElement = sliderElement;
        this.slides = document.querySelectorAll('.js-slides');
        this.arrowNext = this.sliderElement.querySelector('.swiper-button-next');
        this.arrowPrev = this.sliderElement.querySelector('.swiper-button-prev');
        this.pagination = this.sliderElement.querySelector('.swiper-pagination');
        this.scrollbar = this.sliderElement.querySelector('.swiper-scrollbar');
        this.init()
    }

    init() {
        new Swiper(this.sliderElement, {
            slidesPerView: 1.1,
            spaceBetween: 8,
            threshold: 10,
            speed: 400,
            pagination: {
                el: this.pagination
            },
            navigation: {
                nextEl: this.arrowNext,
                prevEl: this.arrowPrev
            },
            scrollbar: {
                el: this.scrollbar,
                draggable: true,
                hide: false
            },
            breakpoints: {
                768: {
                    slidesPerView: 2.5
                },
                1024: {
                    slidesPerView: 4.1
                }
            }
        });
    }
}
